import { useState, useEffect } from 'react';
import axios from 'axios';
import './DownloadFilesSelector.scss';
import { languageElements } from './DownloadFilesSelector-languageElements';
import LanguageElementsHandler from '../../../repository/languageElementsHandler/LanguageElementsHandler';
import { Alert, Button, Spinner } from 'react-bootstrap';
import MemoizedGridReport from '../../gridReport/MemoizedGridReport';
import { getReportParams } from './DownloadFilesSelectorGrid-params';
import FiveSecondsAlert from '../../alerts/fiveSecondsAlert/FiveSecondsAlert';
//import { downloadFiles } from '../../../repository/fileStream/DownloadManager';
import JsFileDownloader from 'js-file-downloader';
import useMain from '../../../common/MainContext';
import { type } from '@testing-library/user-event/dist/type';

export default function DownloadFileSelector(props) {
    const { loginData, language } = useMain();
    const languageElementsHandler = new LanguageElementsHandler(languageElements, language);
    const [data, setData] = useState();
    const [selectedRows, setSelectedRows] = useState([]);
    const [stateOfFiveSecondsAlert, setStateOfFiveSecondsAlert] = useState({
        show: false,
        message: {
            title: '',
            body: '',
        }
    });
    const [gridReportMemo, setGridReportMemo] = useState({});

    const reportParams = getReportParams();

    useEffect(() => {
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/data`,
            {
                collection: props.collection,
                body: {
                    parentRecordId: props.parentRecordId,
                },
            },
            {
                headers: {
                    "x-token": loginData.getToken(),
                }
            }).then((result) => {
                const loadedData = JSON.parse(result.data.result);
                setData(loadedData);
                console.log('+++ loadedData', loadedData);
            }).catch((error) => {
                console.error(error);
            });
    }, [])

    useEffect(() => {
        setGridReportMemo({
            id: 'listOfFiles',
            refreshId: (props.refreshId || 0),
            dataEndpoint: `${process.env.REACT_APP_API_BASE_URL}/data`,
            rowSelection: 'multiple',
            isRowSelectable,
            onSelectionChanged,
            rowMultipleSelectWithClick: true,
            checkboxColumn: 'ID',
            report: {
                collection: props.collection,
                reportParams,
                languageElements,
                data,
            }
        })
    }, [props.refreshId || 0, data])

    function download() {
        if (!selectedRows.length) {
            setStateOfFiveSecondsAlert({
                show: true,
                variant: 'danger',
                interval: 1000,
                className: 'text-center',
                message: {
                    title: languageElementsHandler.get(`alert-no-document-selected`),
                }
            });

            return;
        }

        const files = selectedRows.map(r => ({ id: r.ID, doctype: r.DocType }));

        for (let i = 0; i < files.length; i++) {
            new JsFileDownloader(
                {
                    url: `${process.env.REACT_APP_API_BASE_URL}/docman/file`,
                    forceDesktopMode: true,
                    headers: [
                        { name: 'token', value: loginData.getToken() },
                        { name: 'fileid', value: files[i].id },
                        { name: 'doctype', value: files[i].doctype },
                    ],
                })
                .catch(error => {
                    console.error(error)
                })
        }

        //downloadFiles({ token: loginData.getToken(), fileIDs })
        props.onClose();
    }

    function isRowSelectable() {
        return true;
    }

    function onSelectionChanged(setOfSelectedRows) {
        setSelectedRows(setOfSelectedRows);
    }

    return (
        <div className='form-download-files-selector fullpage'>
            <div className="grid-area">
                <FiveSecondsAlert
                    show={stateOfFiveSecondsAlert.show}
                    message={stateOfFiveSecondsAlert.message}
                    variant={stateOfFiveSecondsAlert.variant}
                    interval={stateOfFiveSecondsAlert.interval}
                    className={stateOfFiveSecondsAlert.className}
                    callback={() => { setStateOfFiveSecondsAlert({ show: false }); }}
                />

                {
                    (!data) &&
                    <Alert variant={props.variant || "info"} className={`mb-0 ${props.className}`}>
                        <div className='spinner-centered'>
                            <Spinner animation='border' variant={props.variant || 'info'} />
                        </div>
                    </Alert>
                }

                {
                    (data) &&
                    <MemoizedGridReport gridReportMemo={gridReportMemo} />
                }
            </div>

            <div className="btn-area">
                <Button variant='success' onClick={download}>
                    {languageElementsHandler.get(`modal-button-download`)}
                </Button>
            </div>
        </div>
    )
}
